var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 216,
    viewBox: "0 0 187 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.852,
    cy: 150.707,
    r: 1.84539,
    fill: "#FF0038"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.84539,
    cy: 42.4441,
    r: 1.84539,
    fill: "#FF0038"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.079,
    cy: 47.9802,
    r: 3.69079,
    fill: "#FF0038"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9932,
    cy: 188.23,
    r: 2.46053,
    fill: "#FF0038"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.638,
    cy: 29.5262,
    r: 1.23026,
    fill: "#FF0038"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.184,
    cy: 211.605,
    r: 3.69079,
    fill: "#FF0038"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.77,
    cy: 110.724,
    r: 1.23026,
    fill: "#FF0038"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.23026,
    cy: 129.178,
    r: 1.23026,
    fill: "#FF0038"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.497,
    cy: 3.07566,
    r: 3.07566,
    fill: "#FF0038"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.783,
    cy: 49.2105,
    r: 2.46053,
    fill: "#FF0038"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.352,
    cy: 197.457,
    r: 1.84539,
    fill: "#FF0038"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9933,
    cy: 140.25,
    r: 3.69079,
    fill: "#FF0038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1379 54.1315L164.855 167.316",
    stroke: "#FF0038",
    strokeWidth: 3.05384,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0239 67.6315C79.3384 68.3122 70.7612 66.8146 65.9365 55.378C63.2058 55.2573 59.2046 55.7864 54.7467 57.5012M83.0239 144.216H52.8697V87.0329L45.8337 95.202L30.7566 81.9273C33.3524 75.9938 36.5398 71.3067 39.9628 67.6315M81.0137 67.6315C84.6992 68.3122 93.2764 66.8146 98.1011 55.378C105.807 55.0376 123.632 59.8709 133.281 81.9273",
    stroke: "black",
    strokeWidth: 3.05384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.927 147.016L146.093 88.6781H94.8312L94.103 95.9604M153.404 164.24L153.783 165.571H125.955L123.309 136.559M92.6267 110.724L87.1419 165.571H114.97L118.105 135.944M119.186 119.335L120.462 105.338L122.411 119.951",
    stroke: "black",
    strokeWidth: 3.05384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart_empty.d03ec0a6b88021ff2504037dca041cb3.svg";
export { ForwardRef as ReactComponent };